import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion, Header, Responsive } from 'semantic-ui-react';
import i18n from 'i18next';
import ContactForm from './ContactForm';
import Loading from '../loading/Loading';
import Cart from '../order/cart/Cart';
import UpsellsModal from '../order/menu/UpsellsModal';
import PaymentSetup from '../payment-setups/PaymentSetup';
import ItemToConstruction from '../order/cart/ItemToConstruction';
import { usePageTitle } from '../../hooks';
import { triggerUpsell } from '../../actions';

import './Checkout.scss';

const Checkout = () => {
    const dispatch = useDispatch();
    const [activeIndex, setActiveIndex] = useState(0);
    const isLoading = useSelector(state => state.loading.queue.length > 0);
    const customer = useSelector(state => state.customer);

    usePageTitle('pageTitles.checkout');

    useEffect(() => {
        dispatch(triggerUpsell(-1));
    }, [dispatch]);

    return (
        <div className="pi-checkout">
            <Loading showLoading={isLoading} />
            <Responsive minWidth={769} className="pi-checkout-cart-wrapper">
                <div className="pi-cart-container">
                    <Cart readOnly={true} />
                </div>
            </Responsive>
            <Accordion styled>
                <Accordion.Title
                    active={activeIndex === 0}
                    index={0}
                    onClick={() => setActiveIndex(0)}
                >
                    <Header>
                        {i18n.t('contact.title')}
                        <Header.Subheader style={{ display: activeIndex ? undefined : 'none' }}>
                            <span>{customer.name}</span>
                            <span>{' | '}</span>
                            <span>{customer.phone}</span>
                            <span>{' | '}</span>
                            <span>{customer.email}</span>
                        </Header.Subheader>
                    </Header>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                    <ContactForm onSubmit={() => setActiveIndex(1)} />
                </Accordion.Content>

                <Accordion.Title
                    active={activeIndex === 1}
                    index={1}
                    style={{ display: activeIndex ? undefined : 'none' }}
                >
                    <Header>{i18n.t('payment.paymentDetails')}</Header>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 1}>
                    {activeIndex === 1 && <PaymentSetup />}
                </Accordion.Content>
            </Accordion>
            <ItemToConstruction />
            <UpsellsModal />
        </div>
    );
};

Checkout.propTypes = {

};

export default Checkout;
